<template>
  <v-navigation-drawer app location="left" v-model="drawer" width="250" height="100%" class="k-app-sidebar">
    <div class="d-flex gap-2 px-4 py-3">
      <div>
        <v-img :to="`/${this.user.active_workspace_id}/`" :src="this.kyano.logo" color="var(--primary-300)" width="40"
          height="24"></v-img>
      </div>
    </div>



    <div class="k-app-sidebar-body">
      <v-list class="menu-small" density="compact" nav :lines="false" :color="`${activeWorkspace?.color || '#24a1c7'}`">
        <v-list-item v-for="(item, index) in getbackMenuItems()" :key="index" :to="item.to">
          <template v-slot:prepend>
            <div class="menu-icon-left">
              <i :class="`fal ${item.icon}`"></i>
            </div>
          </template>
          <template v-slot:append>
            <v-chip v-if="item.append" variant="flat" size="small" color="red">{{ item.append }}</v-chip>
          </template>

          <v-list-item-title v-text="item.title"></v-list-item-title>
        </v-list-item>
      </v-list>
      <div class="pa-3">
        <p class="text-overline">Workspace settings</p>
      </div>
      <v-list class="menu-small" density="compact" nav :lines="false" :color="`${activeWorkspace?.color || '#24a1c7'}`">
        <v-list-item v-for="(item, index) in getMenuItems()" :key="index" :to="item.to">
          <template v-slot:prepend>
            <div class="menu-icon-left">
              <i :class="`fal ${item.icon}`"></i>
            </div>
          </template>
          <template v-slot:append>
            <v-chip v-if="item.append" variant="flat" size="small" color="red">{{ item.append }}</v-chip>
          </template>

          <v-list-item-title v-text="item.title"></v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <div class="pa-3">
        <p class="text-overline">My Account</p>
      </div>
      <v-list class="menu-small" density="compact" nav :lines="false" :color="`${activeWorkspace?.color || '#24a1c7'}`">

        <v-list-item v-for="(item, index) in getMyMenuItems()" :key="index" :to="item.to">
          <template v-slot:prepend>
            <div class="menu-icon-left">
              <i :class="`fal ${item.icon}`"></i>
            </div>
          </template>
          <template v-slot:append>
            <v-chip v-if="item.append" variant="flat" size="small" color="red">{{ item.append }}</v-chip>
          </template>

          <v-list-item-title v-text="item.title"></v-list-item-title>
        </v-list-item>

        <v-list-item @click="logout">
          <template v-slot:prepend>
            <div class="menu-icon-left">
              <i :class="`fal fa-sign-out`"></i>
            </div>
          </template>

          <v-list-item-title v-text="'Sign out'"></v-list-item-title>
        </v-list-item>
      </v-list>
    </div>


  </v-navigation-drawer>
</template>

<script>
import { mapState } from "pinia";
import { useMainStore } from "@/stores/store"; // Adjust this path to your store location
import cookies from "js-cookie";

export default {
  data() {
    return {
      drawer: true,
      selectedmenuitems: [],
      workspaces: {},
      workspaces_list: [],
    };
  },

  computed: {
    ...mapState(useMainStore, ["user", "workspaces", "kyano"]),

    workspace_id() {
      return this.user.active_workspace_id;
    },


  },
  methods: {
    getbackMenuItems() {
      return [
        { title: "Back to workspace", to: `/${this.workspace_id}/`, icon: "fa-arrow-left" },

      ];
    },

    getMenuItems() {
      return [
        {
          title: "Settings",
          to: `/${this.workspace_id}/settings/team/${this.workspace_id}/general`,
          icon: "fa-cog",
        },
        {
          title: "Billing",
          to: `/${this.workspace_id}/settings/team/${this.workspace_id}/billing`,
          icon: "fa-money-check-alt",
        },
        {
          title: "Manage users",
          to: `/${this.workspace_id}/settings/team/${this.workspace_id}/users`,
          icon: "fa-users",
        },
        {
          title: "Workspaces",
          to: `/workspaces`,
          icon: "fa-building",
        },
      ];
    },

    getMyMenuItems() {
      return [


        {
          title: "My settings",
          to: `/${this.workspace_id}/settings/team/${this.workspace_id}/me`,
          icon: "fa-user",
        },
        {
          title: "Notifications",
          to: `/${this.workspace_id}/settings/team/${this.workspace_id}/notifications`,
          icon: "fa-bell-on",
        },

      ];
    },

    logout() {
      cookies.remove('kyano_access_token');
      cookies.remove('kyano_user');
      location.replace('/login');
    },
  },

};
</script>
